module.exports = __webpack_public_path__ + "static/media/Twitter.97f75dda.png";